export const POPOVER_SURFACE_CLASSES =
    'rounded border border-grey-500 bg-grey-600 shadow-dropdown-medium';
